import { render } from "./CategoriesCard.vue?vue&type=template&id=8219d0a6"
import script from "./CategoriesCard.vue?vue&type=script&lang=js"
export * from "./CategoriesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__